import React, {forwardRef} from "react";
import {css, cx} from "@panda/css";

import {Container, Row} from "@pg-design/grid-module";

interface IProps {
    children?: React.ReactNode;
    fluid?: boolean;
    className?: string;
    rowClassName?: string;
    ["data-id"]?: string;
    id?: string;
}

export const ColumnList = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    return (
        <Container className={props.className} fluid={props.fluid} id={props.id} data-id={props["data-id"]}>
            <Row ref={ref} as="ul" className={cx(columnListStyle, props.rowClassName)}>
                {props.children}
            </Row>
        </Container>
    );
});

const columnListStyle = css({
    listStyleType: "none",
    rowGap: "2.4rem"
});
import React, {forwardRef} from "react";
import {css, cx} from "@panda/css";

import {Container, Row} from "@pg-design/grid-module";

interface IProps {
    children?: React.ReactNode;
    fluid?: boolean;
    className?: string;
    rowClassName?: string;
    ["data-id"]?: string;
    id?: string;
}

export const ColumnList = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    return (
        <Container className={props.className} fluid={props.fluid} id={props.id} data-id={props["data-id"]}>
            <Row ref={ref} as="ul" className={cx(columnListStyle, props.rowClassName)}>
                {props.children}
            </Row>
        </Container>
    );
});

const columnListStyle = css({
    listStyleType: "none",
    rowGap: "2.4rem"
});
